module.exports = __webpack_public_path__ + "img/chevron-left.a8fadd99.svg";